import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetEuropaceProcessEvents } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery.ts';

export const useEuropaceProcessEvents = ({ loanRequestId }: { loanRequestId: string | undefined }) => {
    return useAggregateQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getEuropaceProcessEvents,
        schema: schemaLoanRequestResolver_GetEuropaceProcessEvents,
        searchParams: { id: loanRequestId },
    });
};
